import { combineReducers } from 'redux'
import R from 'ramda'
import moment from 'moment'
import * as ANS from './action-names'
import { getMetaConfig } from '../utils'

// const screenSize = (state = { width: 0, height: 0 }, action) => {
//   switch (action.type) {
//     case ANS.WINDOW_SIZE_CHANGE:
//       return action.payload
//   }
//   return state
// }

const fetchTaskCredentials = getMetaConfig('fetchTaskCredentials')

const apiTargetInfo = (
  state = {
    baseUrl: 'http://localhost:9898',
    fetchCredentials: fetchTaskCredentials,
  },
  action
) => {
  switch (action.type) {
    case ANS.STORE_API_URL:
      return { ...state, baseUrl: action.payload }
    case ANS.STORE_JWT:
      return { ...state, jwt: action.payload }
  }
  return state
}
const today = moment().subtract(1, 'month')
const transDate = (state = today, action) => {
  switch (action.type) {
    case ANS.STORE_TRANS_DATE:
      return action.payload
  }
  return state
}

const endDate = (state = today, action) => {
  switch (action.type) {
    case ANS.STORE_END_DATE:
      return action.payload
  }
  return state
}

const unitSorter = (a, b) => a.unitName.localeCompare(b.unitName)

// const causeCode = (state = [], action) => {
//   switch (action.type) {
//     case ANS.CAUSE_CODE: {
//       return action.payload
//     }
//   }
//   return state
// }

const eventTypes = (state = [], action) => {
  switch (action.type) {
    case ANS.EVENT_TYPES: {
      return action.payload
    }
  }
  return state
}

const station = (state = [], action) => {
  switch (action.type) {
    case ANS.STATIONS: {
      return action.payload
    }
  }
  return state
}

const processUnitYpeCode = R.compose(
  R.fromPairs,
  R.map(a => [a.unitCode, a.unitCode + '-' + a.description])
)

const unitTypeCode = (state = [], action) => {
  switch (action.type) {
    case ANS.STORE_UNIT_TYPE_CODE: {
      let code = action.payload || []
      code = code.sort((a, b) => a.description - b.description)
      return processUnitYpeCode(code)
    }
  }
  return state
}

const units = (state = [], action) => {
  switch (action.type) {
    case ANS.STORE_UNITS:
      return action.payload.sort(unitSorter)
  }
  return state
}

// const toUnitNameMap = R.compose(
//   R.fromPairs,
//   R.sortBy(([_, name]) => name.toLowerCase()),
//   R.map(d => [d.unitId, d.unitName])
// )

// const utilityStationMap = (state = {}, action) => {
//   switch (action.type) {
//     case ANS.STORE_UNITS: {
//       const us = {}
//       action.payload.forEach(f => {
//         const c = us[f.utility] || []
//         if (!c.includes(f.station)) {
//           c.push(f.station)
//           us[f.utility] = c
//         }
//       })
//       return us
//     }
//   }
//   return state
// }

const userRoles = (state = {}, action) => {
  switch (action.type) {
    case ANS.STORE_USER_ROLES: {
      return action.payload
    }
  }
  return state
}

// const stationUtilityMap = (state = {}, action) => {
//   switch (action.type) {
//     case ANS.STORE_UNITS: {
//       const st = R.compose(
//         R.reduce((a, b) => ({ ...a, ...b }), {}),
//         R.map(([a, b]) => ({ [a]: R.uniq(b.map(z => z.val)) })),
//         R.toPairs,
//         R.groupBy(u => u.key),
//         R.map(u => ({ key: u.station, val: u.utility })),
//         R.filter(u => u.station !== undefined)
//       )(action.payload)
//       return st
//     }
//   }
//   return state
// }
const utilities = (state = [], action) => {
  switch (action.type) {
    case ANS.STORE_UTILITY: {
      return action.payload
    }
  }
  return state
}

// const utilityNameMap = (state = {}, action) => {
//   switch (action.type) {
//     case ANS.STORE_UTILITY: {
//       return R.compose(
//         // R.reduce((a, b) => ({ ...a, ...b }), {}),
//         // R.map(([k, v]) => ({ [k]: v })),
//         R.fromPairs,
//         R.sortBy(([_, name]) => name.toLowerCase()),
//         R.map(u => [u.utility, u.utilityName])
//       )(action.payload || [])
//     }
//   }
//   return state
// }

// const companyUtilityMap = (state = {}, action) => {
//   switch (action.type) {
//     case ANS.STORE_UTILITY: {
//       let ut = action.payload || []

//       ut = R.compose(
//         v => R.mapObjIndexed((n, k) => R.map(s => s.utility, v[k]))(v),
//         R.groupBy(c => c.companyId)
//       )(ut)
//       return ut
//     }
//   }
//   return state
// }

const reportNameMap = (state = {}, action) => {
  switch (action.type) {
    case ANS.STORE_REPORTNAME_MAP: {
      return action.payload || {}
    }
  }
  return state
}
const reportDisplayCodeMap = (state = {}, action) => {
  switch (action.type) {
    case ANS.STORE_REPORT_DISPLAYCODE_MAP: {
      return action.payload || {}
    }
  }
  return state
}

// const userReport = (state = [], action) => {
//   switch (action.type) {
//     case ANS.STORE_USER_REPORT: {
//       return action.payload || []
//     }
//   }
//   return state
// }

const unitNameMap = (state = {}, action) => {
  switch (action.type) {
    case ANS.STORE_UNIT_NAME_MAP:
      return action.payload
  }
  return state
}

const unitGroups = (state = [], action) => {
  switch (action.type) {
    case ANS.STORE_UNIT_GROUPS:
      return action.payload
  }
  return state
}

const hrsInDay = (state = [], action) => {
  switch (action.type) {
    case ANS.STORE_HOURS_IN_DAY:
      return action.payload
  }
  return state
}

const fuzzyStr = (state = '', action) => {
  switch (action.type) {
    case ANS.STORE_FUZZY_STR:
      return action.payload
  }
  return state
}

// const filteredUnitGroup = (state = null, action) => {
//   switch (action.type) {
//     case ANS.STORE_FILTERED_UNIT_GROUP:
//       return action.payload
//   }
//   return state
// }

// const filteredUnits = (state = [], action) => {
//   switch (action.type) {
//     case ANS.STORE_FILTERED_UNITS:
//       return action.payload
//   }
//   return state
// }

const envConfig = (state = {}, action) => {
  switch (action.type) {
    case ANS.STORE_ENV_CONFIG:
      return { ...state, ...action.payload }
  }
  return state
}

// const strSorter = (a, b) => a.localeCompare(b)

// const pjmFuelType = (state = {}, action) => {
//   switch (action.type) {
//     case ANS.STORE_PJM_FUEL_TYPE:
//       const process = R.compose(
//         R.fromPairs,
//         R.map(([key, values]) => [key, values.map(f => f.sub).sort(strSorter)]),
//         R.toPairs,
//         R.groupBy(d => d.primary)
//       )
//       return process(action.payload)
//   }
//   return state
// }

const failCodeList = R.compose(
  R.fromPairs,
  R.map(a => [a.code, `[${a.code}]${a.description}`])
)
const ampCodeList = R.compose(
  R.fromPairs,
  R.map(a => [a.ampCode, `[${a.ampCode}]${a.description}`])
)

const amplification = (state = [], action) => {
  switch (action.type) {
    case ANS.STORE_AMPLIFICATION: {
      return ampCodeList(action.payload)
    }
  }
  return state
}

const failCode = (state = [], action) => {
  switch (action.type) {
    case ANS.STORE_FAILCODE: {
      return failCodeList(action.payload)
    }
  }
  return state
}

const userInfo = (state = {}, action) => {
  switch (action.type) {
    case ANS.STORE_USERINFO: {
      return action.payload
    }
  }
  return state
}

const createSimpleReducer = ({ defaultState = [], actionName }) => (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case actionName:
      return action.payload
  }
  return state
}

const error = (state = null, action) => {
  switch (action.type) {
    case ANS.STORE_ERROR: {
      return action.payload || null
    }
  }
  return state
}

const pnodeZoneEffective = (state = [], action) => {
  switch (action.type) {
    case ANS.STORE_PNODE_ZONE_EFFECTIVE: {
      return action.payload || []
    }
  }
  return state
}

const contribConditionList = (state = [], action) => {
  switch (action.type) {
    case ANS.STORE_CARD97_CONT_OP_COND: {
      return action.payload || []
    }
  }
  return state
}

export default combineReducers({
  apiTargetInfo,
  error,
  userInfo,
  userRoles,
  // screenSize,
  transDate,
  endDate,
  // filteredUnits,
  units,
  unitTypeCode,
  utilities,
  unitNameMap,
  unitGroups,
  // filteredUnitGroup,
  hrsInDay,
  fuzzyStr,
  envConfig,
  // pjmFuelType,
  // causeCode,
  eventTypes,
  station,
  // utilityStationMap,
  // companyUtilityMap,
  // utilityNameMap,
  pnodeZoneEffective,
  reportNameMap,
  reportDisplayCodeMap,
  // userReport,
  // stationUtilityMap,
  // utilityNameMap: createSimpleReducer({
  //   actionName: ANS.STORE_UTILITY_NAME_MAP,
  //   defaultState: {},
  // }),
  amplification,
  failCode,
  companyNameMap: createSimpleReducer({
    actionName: ANS.STORE_COMPANY_NAME_MAP,
    defaultState: {},
  }),
  loginError: createSimpleReducer({
    actionName: ANS.STORE_LOGIN_ERROR,
    defaultState: null,
  }),
  twoFactorRegistration: createSimpleReducer({
    actionName: ANS.STORE_2FA_REGISTRATION,
    defaultState: null,
  }),
  twoFactorCodeRequired: createSimpleReducer({
    actionName: ANS.STORE_2FA_REQUIRED,
    defaultState: false,
  }),
  twoFactorOptions: createSimpleReducer({
    actionName: ANS.STORE_2FA_OPTIONS,
    defaultState: 'authenticator',
  }),

  // pjmUnitClass: createSimpleReducer({
  //   actionName: ANS.STORE_PJM_UNIT_CLASS,
  //   defaultState: [],
  // }),
  // utilityUnitsMap: createSimpleReducer({
  //   actionName: ANS.STORE_UTILITY_UNITS_MAP,
  //   defaultState: {},
  // }),
  // unitCodeCauseCodeMap: createSimpleReducer({
  //   actionName: ANS.STORE_UNIT_CAUSE_CODE_MAP,
  //   defaultState: {},
  // }),
  // causeCodeMap: createSimpleReducer({
  //   actionName: ANS.STORE_CAUSE_CODE_MAP,
  //   defaultState: {},
  // }),
  causeCodeData: createSimpleReducer({
    actionName: ANS.STORE_CAUSE_CODE_TABLE,
    defaultState: {},
  }),
  loadingUnits: createSimpleReducer({
    actionName: ANS.LOADING_UNITES,
    defaultState: false,
  }),
  loadingInitData: createSimpleReducer({
    actionName: ANS.LOADING_INIT_DATA,
    defaultState: false,
  }),
  contribConditionList,
})
